/*
*	MG2 Media JS Framework
*	@author  François Vandal
*	@version: 0.9.4
*	Last update: 6 september 2016
*/

(function($, global, undefined) {
	var html = $('html');
	var lang = html.attr('lang');
	var defaultLang = html.attr('data-default-lang');
	
	var modules = {};
	var components = {};
	var pages = {};
	
    const toggleSwitch = document.getElementById('toggle-switch');
	if(toggleSwitch!=null && toggleSwitch!=undefined){
		var updateField= toggleSwitch.getAttribute("update-field");
	
		toggleSwitch.addEventListener('change', function() {
			$("input[name='"+updateField+"']").val(toggleSwitch.checked?"a":"i");
		});
	}
  

	/* Modules */
	var createModule = function (module) {
		return $.extend({
			init: $.noop,
			pageLoad: $.noop, 
			pageChange: $.noop,  
			pageEnter: $.noop,
			pageLeave: $.noop,
			pageStartChange: $.noop
		}, module);
	};
	
	var exportModule = function (key, module) {
		modules[key] = createModule(module);
		
		return modules[key];
	};
	
	
	/* Pages */
	var createPage = function (page) {
		return $.extend({
			init: $.noop,
			pageLoad: $.noop,
			pageEnter: $.noop,
			pageLeave: $.noop
		}, page);
	};
	
	var exportPage = function (key, page) {
		pages[key] = createPage(page);
		
		return pages[key];
	};
	
	var checkForPage = function (pageIdNum) {
		var currPage = $('.main-content .page[data-page-id-num='+pageIdNum+']').attr('data-page-id');
		
		if (pages[pageIdNum] !== undefined) {
			pages[pageIdNum].init('#page-'+currPage);
			pages[pageIdNum].pageLoad('#page-'+currPage);
		}
	};
	
	
	/* Components */
	var createComponent = function (component) {
		return $.extend({init: $.noop}, component);
	};
	
	var exportComponent = function (key, component) {
		components[key] = createPage(component);
		
		return pages[key];
	};
	
	
	var start = function () {
		var lang = $('html').attr('lang');
		var defaultLang = $('html').attr('data-default-lang');
		
		var currPathname = location.pathname;
		var currentIdNum = $('.main-content .page').data('pageIdNum');
		
		if (currPathname !== '/' && currPathname.substring(0, 1) === '/') {
			currPathname = currPathname.substring(1);
		}
		
		if (lang !== defaultLang) {
			currPathname = currPathname.substring(lang.length);
		}
		
		currPathname = currPathname !== '/' ? currPathname : 'home';
		
		if (currPathname.substring(currPathname.length - 1) === '/') {
			currPathname = currPathname + 'home';
		}
		
		if (currPathname.substring(0, 1) === '/') {
			currPathname = currPathname.substring(1);
		}
		
		currPathname = currPathname.split('?')[0];
		if (currPathname.substring(currPathname.length - 1) === '/') {
			currPathname = currPathname.substring(0, currPathname.length - 1);
		}
		
		if (lang !== defaultLang) {
			if(currPathname.substring(0, lang.length) === lang) {
				currPathname = currPathname.substring(lang.length);
			}
		}
		
		if (currPathname.substring(0, 1) === '/') {
			currPathname = currPathname.substring(1);
		}
		
		currPathname = currPathname.split('/')[0];
		
		$.each(Fw.modules.models(), function () {
			this.init('body');
			this.pageLoad('body');
		});
		
		$('html').attr('data-curr-page', 'page-' + currPathname);
		checkForPage(currentIdNum);
		
		return Fw;
	};
	
	global.Fw = $.extend(global.Fw, {
		data: '',
		
		modules: {
			models: function () {
				return modules;
			},
			
			export: exportModule
		},
		
		component: {
			models: function () {
				return components;
			},
			
			export: exportComponent
		},
		
		page: {
			models: function () {
				return pages;
			},
			
			export: exportPage,
			
			checkForPage: checkForPage
		},
		
		start: start
	});
	
	window.cloneCoordsTemplate= function(coordsData){
		var itemTemplate=$(".add-modify-page-inner-geofence-ctn-location-item-template");
		var id=$(".add-modify-page-inner-geofence-ctn-location-item").length+1;
		var clone=itemTemplate.clone();
		clone.removeClass("add-modify-page-inner-geofence-ctn-location-item-template").addClass("add-modify-page-inner-geofence-ctn-location-item");
		clone.attr("id","buildingId"+id);
		clone.attr("geofence-data",coordsData.coords);
		clone.find(".first").html(coordsData.name);
		clone.show();
		
		clone.appendTo("#geofence-list-inner");
		return clone;
	}

	// window.addNFCInInput=function(id,div){
		// try {
		// 	var jsonObject = JSON.parse($("input[name='nfcs-details']").val());

		// 	jsonObject[`${id}`]={deleted:false,field31:div.parent().parent().parent().parent().attr("data-id")};

		// 	$("input[name='nfcs-details']").val(JSON.stringify(jsonObject));
		// } catch (error) {
		// 	var jsonObject = {};

		// 	jsonObject[`${id}`]={deleted:false,field31:div.parent().parent().parent().parent().attr("data-id")};

		// 	$("input[name='nfcs-details']").val(JSON.stringify(jsonObject));
		// }
	// }

	window.updateNFCSelects=function() {
		const ids = $(`.js-nfc-list-item-delete`).map((_, el) => Number(el.dataset.id)).get();
		$('[name="nfc-tag"] option').prop('disabled', false).show();
		ids.forEach(id => {
			$(`[name="nfc-tag"] option[value="${id}"]`).prop('disabled', true).hide();
		});
	}
	
	window.onRemoveNFCClick=function({ currentTarget }) {
		const li=$(currentTarget).closest('li');
		const id=li.find(".js-nfc-list-item-delete").attr("data-id");
		li.remove();

		window.parent.updateNFCSelects();
	}
	window.updateHiddenSelect2=function(item){
		var selects=item.find(".form-select-ctn");
      
		$(selects).each((i,el)=>{
			var selectDiv=$(el);
			
			var id=selectDiv.find(".updated-select-input").attr("id");
			var name=selectDiv.find(".updated-select-input").attr("name");
			var dataId=selectDiv.find(".updated-select-input").attr("data-id");
			var dataExtra=selectDiv.find(".updated-select-input").attr("data-extra");
			var isRequired=selectDiv.find(".updated-select-input").hasClass("required");
			var disabled=selectDiv.find(".updated-select-input").attr("disabled");

			selectDiv.find(".updated-select-input").remove();
			
			selectDiv.find(".select2.select2-container.select2-container--default").remove();
			
			var select=selectDiv.find(".updated-select-input-hidden").clone();
			select.removeClass("updated-select-input-hidden").addClass("updated-select-input");

			if(id!==undefined)
				select.attr("id",id);
			if(name!==undefined){
				select.attr("name",name);
			}if(dataId!==undefined)
				select.attr("data-id",dataId);
			if(dataExtra!==undefined)
				select.attr("data-extra",dataExtra);
			if(isRequired)
				select.addClass("required");
			if(disabled!==undefined)
				select.attr("disabled",disabled);
			
			select.addClass("form-select form-input");
			select.removeClass("updated-select-input-hidden").addClass("updated-select-input");
			select.appendTo(selectDiv);
			
			window.parent.initializeSelect2(select);
		});
	}

	window.updateHiddenSelect= function(item,newId){
		var selectDiv=$(item).find(".form-select-ctn");
		
		var id=selectDiv.find(".updated-select-input").attr("id");
		var name=selectDiv.find(".updated-select-input").attr("name");
		var dataId=selectDiv.find(".updated-select-input").attr("data-id");
		var dataExtra=selectDiv.find(".updated-select-input").attr("data-extra");
		var isRequired=selectDiv.find(".updated-select-input").hasClass("required");
		var disabled=selectDiv.find(".updated-select-input").attr("disabled");

		selectDiv.find(".updated-select-input").remove();
		
		selectDiv.find(".select2.select2-container.select2-container--default").remove();
		
		var select=selectDiv.find(".updated-select-input-hidden").clone();
		select.removeClass("updated-select-input-hidden").addClass("updated-select-input");

		if(id!==undefined)
			select.attr("id",id+"-"+newId);
		if(name!==undefined){
			select.attr("name",name);
		}if(dataId!==undefined)
			select.attr("data-id",dataId);
		if(dataExtra!==undefined)
			select.attr("data-extra",dataExtra);
		if(isRequired)
			select.addClass("required");
		if(disabled!==undefined)
			select.attr("disabled",disabled);
		select.addClass("form-select form-input");

		var isRequired=selectDiv.find(".updated-select-input").hasClass("required");
		var disabled=selectDiv.find(".updated-select-input").attr("disabled");
		
		select.appendTo(selectDiv);
		window.parent.initializeSelect2(select);
	}

	window.addComponent=function(dropdownOption,containerId){
		return window.parent.addGenComponent(dropdownOption,"responseOption","containerId"+containerId,"response-type-container-item",".add-response-edit-location",null);
	}

	window.addPictureComponent=function(filename,containerId,filenameGen){
		var id=window.parent.addGenComponent(filename,"pictureLi","pictureContainerId"+containerId,"picture-container-item",".add-picture-edit-location",filenameGen);
		return id;
	}

	window.addGenComponent=function(cName,cPrefix,containerId,containerCls,editBtnCls,cFilename){
		var container=$("."+containerId);
		var totalEle=container.find("."+containerCls).length;
		var cClone=$("."+containerCls+"-hidden").clone();
		var textBoxId=cPrefix+totalEle+containerId;
		cClone.removeClass(containerCls+"-hidden").addClass(containerCls);
		
		cClone.find(".first").html(cName);
		cClone.find(".first").addClass(textBoxId);
		cClone.find(editBtnCls).attr("data-str-box-id",textBoxId);
		
		if(cFilename)
			cClone.find(editBtnCls).attr("data-filename",cFilename);
		
		container.append(cClone);
		return textBoxId;
	}

	window.initializeDataTable=function(table){
		table.DataTable({
			lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
			layout: {
				topStart: {
					buttons: ["pageLength",
						{
							extend: 'collection',
							text: 'Download',
							buttons: ['excelHtml5', 'csvHtml5', 'pdfHtml5']
						}
					]
				}
			}
		});
	}

	window.initializeMultiSelect2=function(select){
		function stripDiacritics (text) {
			function match(a) {
				return DIACRITICS[a] || a;
			}

			return text.replace(/[^\u0000-\u007E]/g, match);
		}

		function matcher(params,data){
			if (params.term == null || params.term.trim() === '') {
				return data;
			}
			
			if (data.children && data.children.length > 0) {
				var match = $.extend(true, {}, data);

				for (var c = data.children.length - 1; c >= 0; c--) {
					var child = data.children[c];

					var matches = matcher(params, child);

					if (matches == null) {
						match.children.splice(c, 1);
					}
				}
				
				if (match.children.length > 0) {
					return match;
				}

				return matcher(params, match);
			}

			var original = stripDiacritics(data.text).toUpperCase();
			var term = stripDiacritics(params.term).toUpperCase();

			if (original.indexOf(term) > -1) {
				return data;
			}
			return null;
		}

		select.select2({
			matcher: matcher,
			templateResult:(state)=>{
				if (!state.id) return state.text;
				var id = state.id.toLowerCase();
				var label = '<label for="'+id+'">'+state.text+'</label>';
				var checkbox = $(
					'<div class="sb-readonly-checkbox">'
						+'<div class="sb-readonly-checkbox-inner"></div>'
						+'<div class="sb-d-flex">'
							+'<div class="sb-flex1">'
								+'<input '+(state.selected==true?'checked="checkekd"':'')+' data-id="'+id+'" id="'+"optioncheckbox-"+id+'" type="checkbox" class="multiple-select-checkbox">'
							+"</div>"
							+'<div class="sb-flex99">'
								+label
							+"</div>"
						+"</div>"
					+'</div>'
				);
				return checkbox;
			},
			templateSelection:(state)=> {
				const id=state.id;
				$("#optioncheckbox-"+String(id).toLocaleLowerCase()).attr("checked",true);
				return state.text;   
			},
			closeOnSelect: false,
			escapeMarkup: function (m) {
				return m;
			},
		}).on('select2:unselect', function (e) {
			var data = e.params.data;
			$("#optioncheckbox-"+String(data.id).toLocaleLowerCase()).attr("checked",false);
		});
	}

	window.initializeSelect2=function(select){
		var disableOrderwise=select.attr("disable-orderwise");
		var dataOptions=select.attr("dataoptions");
		var selectedoption=select.attr("selectedoption");
		if(dataOptions!=undefined && dataOptions!=null && dataOptions){
			dataOptions=JSON.parse(dataOptions);
			
			for(var i=0;i<dataOptions.length;i++){
				var strrr=(selectedoption!=undefined && selectedoption!=null && selectedoption==dataOptions[i]?"selected='selected'":"");
				select.append("<option value='"+dataOptions[i]+"' "+strrr+">"+dataOptions[i]+"</option>");
			}
		  }
			
		if(disableOrderwise=='true'){
			if($(select).hasClass("select2-multiple"))
				window.parent.initializeMultiSelect2(select);
			else
				select.select2();
		}else{
			if($(select).hasClass("select2-multiple"))
				window.parent.initializeMultiSelect2(select);
			else
				select.select2({
					sorter: data => {
						var firstItem=data.shift();
						var tempData=data.sort((a, b) =>a.text.localeCompare(b.text));
						tempData.unshift(firstItem);
						return tempData;
					} 
				});
		}
			
		var container=$(select).siblings('.select2-container');
		if(!($(select).hasClass("select2-multiple"))){
			if($(select).parent().hasClass("half") || $(select).parent().parent().hasClass("half"))
				container.css({'display':'block','max-width':'100%','width':'100%','min-width':'100%'});
			else if($(select).parent().hasClass("two-third") || $(select).parent().hasClass("third"))
				container.css({'max-width':'100%',"width":"100%"});
			else{
				container.css({'width':
					$(select).parent().hasClass("fill") || $(select).parent().parent().hasClass("fill")?
						'100%':$(select).css('width')=='' || $(select).css('width')=='1px'?
							($(select).css('min-width')==''?select.css('max-width'):select.css('min-width')):$(select).css('width')});
			}
			$(container).find(".select2-selection").css({'height': '47px','border': '1px solid #cbccd9','background-color':'inherit','font-size': '1.4rem','font-family': 'Lato,arial,helvetica,sans-serif'});
			$(container).find('.select2-selection__arrow').css({'height': '44px','right':'10'});
			$(container).find('.select2-selection__rendered').css({'line-height': '44px','padding-left':'18px'});
		}else if(($(select).hasClass("select2-multiple")) ){
			$(container).find(".select2-selection").css({'min-height': '47px','border': '1px solid #cbccd9',
			'background-color':'inherit','font-size': '1.4rem',
			'font-family': 'Lato,arial,helvetica,sans-serif'});
			$(container).find('.select2-selection__arrow').css({'height': '44px','right':'10'});
		}
	}
})(jQuery, window);